import { Cast } from '@mui/icons-material'
import VirtualExperienceEdit from './VirtualExperiencesEdit'
import VirtualExperienceCreate from './VirtualExperienceCreate'
import VirtualExperienceList from './VirtualExperiencesList'

const virtualExperienceIndex = {
  icon: Cast,
  list: VirtualExperienceList,
  edit: VirtualExperienceEdit,
  create: VirtualExperienceCreate,
}

export default virtualExperienceIndex
